import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
const { SENTRY_DSN, SENTRY_ENV } = (window as any).__env__;

if (SENTRY_DSN && SENTRY_ENV) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
  });
}

function sanitizePath(path: string): string {
  if (path === '/') {
    return path;
  }

  if (path.match(/^\/(.)+\/$/)) {
    return path;
  }

  let newPath: string;

  if (path[0] !== '/') {
    newPath = `/${path}`;
  } else {
    newPath = path;
  }

  if (path[path.length - 1] !== '/') {
    newPath += '/';
  }

  return newPath;
}

console.log(`Document.referrer: ${document.referrer}`);

const HOST = 'xometry.com';
const PROTOCOL = 'https';
const DEFAULT_WORKFLOW = 'fusion';
const {
  location: {
    protocol: loaderProtocol,
    hostname: loaderHost,
    pathname: loaderPath,
    search,
  },
} = window;
const params = new URLSearchParams(search);
const protocol = params.get('protocol') || loaderProtocol.split(':')[0] || PROTOCOL;
const host = params.get('host') || loaderHost.split('www.')[1] || HOST;
const path = sanitizePath(loaderPath) || '/';

let workflow = params.get('workflow') || DEFAULT_WORKFLOW;
let client = params.get('client');
let { referrer } = document;

switch (workflow) {
  case 'fusion':
    client = 'fusion';
    referrer = 'fusion';
    break;
  case 'onshape':
    client = 'onshape';
    referrer = 'onshape';
    break;
  case 'browser':
    if (!client) {
      client = 'browser';
      referrer = 'browser';
    }
    break;
  case 'solidworks':
    client = 'solidworks';
    referrer = 'solidworks';
    break;
  case 'inventor':
    client = 'inventor';
    referrer = 'inventor';
    break;
  default:
    workflow = 'fusion';
    client = 'fusion';
    referrer = 'fusion';
    break;
}

const Webapp = lazy(() => import(`${protocol}://www.${host}/components/addin-webapp-v2/component.mjs`));

const App = () => (
  <Suspense fallback={<div className="loader">Loading...</div>}>
    <Webapp
      origin={{
        protocol,
        host,
        path,
        client,
        workflow,
        referrer,
      }}
    />
  </Suspense>
);

ReactDOM.render(<App />, document.getElementById('main'));
